// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import device from 'common/support/device';

import Image from 'components/common/Image';

import styles from './PageHeader.module.scss';

const PageHeader = ({
  imageSrc,
  title,
  description,
  hideHeader,
  isVideo,
  logoSrc,
}) => {
  return (
    <div
      className={classNames(styles.backgroundGradient, {
        [styles.animate]: !device.isSlowDevice,
        [styles.showHeader]: !hideHeader,
        [styles.hideHeader]: hideHeader,
      })}
    >
      {isVideo && (
        <div className={styles.headerBackground}>
          <video autoPlay muted id="headerVideo" width="1920px">
            <source src={imageSrc} type="video/mp4" />
          </video>
        </div>
      )}
      {!isVideo && (
        <Image
          alt="page header img"
          src={imageSrc}
          className={styles.headerBackground}
        />
      )}
      <div className={styles.backgroundGradient}>
        <div className="d-flex flex-row h-100 w-100">
          {!!logoSrc && (
            <Image
              alt="page logo"
              src={logoSrc}
              className={styles.headerLogo}
            />
          )}
          <div
            className={classNames(
              'd-flex',
              'flex-column',
              styles.headerText,
              logoSrc ? styles.headerTextWithLogo : '',
            )}
          >
            <span className={styles.headerTitle}>{title}</span>
            <span className={styles.headerDescription}>{description}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  hideHeader: PropTypes.bool,
  isVideo: PropTypes.bool,
  logoSrc: PropTypes.string,
};

PageHeader.defaultProps = {
  imageSrc: null,
  title: null,
  description: null,
  hideHeader: false,
  isVideo: false,
  logoSrc: null,
};

export default PageHeader;
